import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { isDefined } from "../../../Utils";
import Select from "../../Common/FormElements/Select/Select";
import Button from "../../Common/FormElements/Button/Button";
import { useTransporter } from "../../Commandes/DeliveryDialog/hooks/useTransporter";
import { useState } from "react";
import {
  getDeliveryNumber,
  updateDelivery,
} from "../../../REDUX/actions/delivery";
import { useDispatch, useSelector } from "react-redux";
import { closeCenteredModal } from "../../../REDUX/actions/centeredModal";

const TransporterSelectModal = ({ delivery }) => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const { updateDeliveryLoading } = useSelector(
    (state) => state.deliveryReducer
  );
  const { transporterOptions, loading } = useTransporter();
  const [selectedTransporter, setSelectedTransporter] = useState(null);
  const orderNumber = delivery?.attributes?.commande?.data?.attributes?.number;
  const resellerName =
    delivery?.attributes?.commande?.data?.attributes?.reseller?.data?.attributes
      ?.name;

  const handleClick = async () => {
    const nextNumber = await getDeliveryNumber(delivery?.id);
    const payload = {
      transporter: selectedTransporter?.code,
    };
    if (!isDefined(delivery?.attributes?.number)) {
      payload.number = nextNumber;
    }
    dispatch(updateDelivery(delivery?.id, payload));
    dispatch(closeCenteredModal());
  };

  useEffect(() => {
    if (
      !isDefined(delivery?.attributes?.transporter?.data?.id) ||
      !transporterOptions?.length > 0
    )
      return;
    const transporter = transporterOptions.find(
      (transporter) =>
        transporter.code === delivery?.attributes?.transporter?.data?.id
    );
    setSelectedTransporter(transporter);
  }, [delivery?.attributes?.transporter?.data?.id, transporterOptions]);

  return (
    <div className="d-flex flex-column gap-3 justify-content-center transporter-select max-w-500px mx-auto">
      <p className="f16 text-blue bold mb-0">
        {isDefined(orderNumber)
          ? `${t("Order")} ${orderNumber} ${
              isDefined(resellerName) ? `/ ${resellerName}` : ""
            }`
          : ""}{" "}
        {t("Transporter selection")}
      </p>
      <div className="d-flex flex-column gap-2">
        <span className="f16 text-dark">
          {t("Validate the request and choose the transporter")}
        </span>
        <Select
          options={transporterOptions}
          value={selectedTransporter}
          callback={(e) => setSelectedTransporter(e.target.value)}
          placeholder={loading ? t("Loading...") : t("Select")}
          disabled={loading}
        />
      </div>
      <Button
        loading={updateDeliveryLoading}
        disabled={updateDeliveryLoading}
        onClick={handleClick}
      >
        {t("Validate")}
      </Button>
    </div>
  );
};

export default TransporterSelectModal;
